import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f3698616"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "textarea__container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "textarea__label",
  for: "prompt-input"
}, " Image prompt", -1))
const _hoisted_3 = { class: "textarea__grow-wrap" }
const _hoisted_4 = ["placeholder", "onKeydown", "disabled"]
const _hoisted_5 = { class: "textarea__length-info" }

import { GameStatus, RoundStatus, useGameStore } from '@/stores/gameStore';
import { useKeyboardStore } from '@/stores/keyboardStore';
import { useUserStore } from '@/stores/userStore';
import { isPhone } from '@/utils/responsiveHelper';
import { computed, onMounted, ref } from 'vue';

const maxLength = 200;

export default /*#__PURE__*/_defineComponent({
  __name: 'PromptTextArea',
  emits: ['TextArea:triggerSubmit'],
  setup(__props, { emit: __emit }) {

const gameStore = useGameStore();
const userStore = useUserStore();

const textareaRef = ref(null);

const keyboardStore = useKeyboardStore();

const emit = __emit;

function triggerSubmit() {
  if (gameStore.userInput.length !== 0) {
    emit('TextArea:triggerSubmit');
  }
}

const adjustTextarea = () => {
  if (isPhone()) {
    const textarea = textareaRef.value;
    const previousScrollHeight = textarea.scrollHeight;
    textarea.style.height = 'auto';
    textarea.style.height = '1px'; // Set a small height to trigger the scrollHeight

    textarea.style.height = textarea.scrollHeight + 'px';

    // Check if the scrollHeight has increased
    if (textarea.scrollHeight > previousScrollHeight) {
      // Scroll the entire screen to show the last line of the textarea
      window.scrollBy(0, 20);
    }
  }
};

const disabled = computed(() => {
  return (
    gameStore.status === GameStatus.INITIAL ||
    gameStore.roundStatus === RoundStatus.EXPIRED ||
    gameStore.roundStatus === RoundStatus.SUBMITTED ||
    gameStore.roundStatus === RoundStatus.INITIAL ||
    gameStore.loadingImage ||
    gameStore.survived ||
    userStore.lives === 0
  );
});

const inputPlaceholder = computed(() => {
  if (gameStore.userInput !== '') {
    return gameStore.userInput;
  } else {
    return 'Your prompt...';
  }
});

onMounted(() => {
  adjustTextarea(); // Call adjustTextarea on mounted
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _withDirectives(_createElementVNode("textarea", {
        ref_key: "textareaRef",
        ref: textareaRef,
        autofocus: "",
        required: "",
        maxlength: maxLength,
        id: "prompt-input",
        name: "user-prompt",
        class: "textarea-text",
        oninvalid: "this.setCustomValidity('Input for Image Generation is required')",
        onInput: adjustTextarea,
        onClick: _cache[0] || (_cache[0] = () => _unref(keyboardStore).setExpanded(true)),
        onBlur: _cache[1] || (_cache[1] = () => _unref(keyboardStore).setExpanded(false)),
        placeholder: inputPlaceholder.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(gameStore).userInput) = $event)),
        onKeydown: _withKeys(_withModifiers(triggerSubmit, ["exact","prevent"]), ["enter"]),
        disabled: disabled.value
      }, null, 40, _hoisted_4), [
        [_vModelText, _unref(gameStore).userInput]
      ])
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString(maxLength - _unref(gameStore).userInput.length) + " characters left ", 1)
  ]))
}
}

})